module.exports = __webpack_public_path__ + "media/images/logo-31b7fd24a5eaaea1ce4ef9e7037d6d25.png";